define('plugin/promotion/collection/PromotionInstanceCollection',['require','lib/collection/ServerPaginatedCollection','plugin/promotion/model/PromotionInstanceModel'],function (require) {

    var ServerPaginatedCollection = require('lib/collection/ServerPaginatedCollection');
    var PromotionInstanceModel = require('plugin/promotion/model/PromotionInstanceModel');

    /**
     * Promotion collection
     *
     * @class PromotionCollection
     */
    return ServerPaginatedCollection.extend({

        url: '/ext/promotion/instances/',
        model: PromotionInstanceModel

    });

});
